module.exports = __webpack_public_path__ + "static/47-b2b2e1d850d4d8bca57c9bd067861ea1.png";